export default "__VITE_ASSET__u4U9UQ_N__"